<template>
  <div class="user-wrapper">
    <div class="content-box">
<!--      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
<!--          <a-avatar class="avatar" size="small" :src="avatar"/>-->
          <a-icon type="user"/>
          <span style="margin-left: 6px;">{{ this.userInfo.name || this.userInfo.mobile }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
<!--          <a-menu-item key="0">-->
<!--            <router-link :to="{ name: 'center' }">-->
<!--              <a-icon type="user"/>-->
<!--              <span>个人中心</span>-->
<!--            </router-link>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item key="1">-->
<!--            <router-link :to="{ name: 'settings' }">-->
<!--              <a-icon type="setting"/>-->
<!--              <span>账户设置</span>-->
<!--            </router-link>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item key="2" disabled>-->
<!--            <a-icon type="setting"/>-->
<!--            <span>测试</span>-->
<!--          </a-menu-item>-->
<!--          <a-menu-divider/>-->
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
// import NoticeIcon from '@/components/NoticeIcon'
// import { mapActions, mapGetters } from 'vuex'
import getVuexWithNameSpace from '../../utils/storeHelper'

const { mapGetters } = getVuexWithNameSpace('user')
export default {
  name: 'UserMenu',
  components: {
    // NoticeIcon
  },
  data () {
    return {
      avatar: ''
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    // ...mapActions(['Logout']),
    handleLogout () {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () => {
          const loginOut = () => {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                this.$ls.clear()
                resolve()
              }, 1000)
            })
          }
          return loginOut({}).then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 16)
          }).catch(err => {
            this.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
/*.user-wrapper {*/
/*  float: right;*/
/*  height: 100%;*/
/*  .content-box {*/
/*    float: right;*/
/*    .user-dropdown-menu {*/
/*      span {*/
/*        user-select: none;*/
/*      }*/
/*    }*/
/*    .user-dropdown-menu-wrapper.ant-dropdown-menu {*/
/*      padding: 4px 0;*/

/*      .ant-dropdown-menu-item {*/
/*        width: 160px;*/
/*      }*/

/*      .ant-dropdown-menu-item > .anticon:first-child,*/
/*      .ant-dropdown-menu-item > a > .anticon:first-child,*/
/*      .ant-dropdown-menu-submenu-title > .anticon:first-child .ant-dropdown-menu-submenu-title > a > .anticon:first-child {*/
/*        min-width: 12px;*/
/*        margin-right: 8px;*/
/*      }*/
/*    }*/
/*    .action {*/
/*      max-width: 140px;*/
/*      overflow: hidden;*/
/*      text-overflow:ellipsis;*/
/*      white-space:nowrap;*/
/*    }*/
/*  }*/
/*  .action {*/
/*    cursor: pointer;*/
/*    padding: 0 12px;*/
/*    display: inline-block;*/
/*    transition: all 0.3s;*/
/*    height: 100%;*/
/*    color: rgba(0, 0, 0, 0.65);*/

/*    &:hover {*/
/*      background: rgba(0, 0, 0, 0.025);*/
/*    }*/

/*    .avatar {*/
/*      margin: 20px 8px 20px 0;*/
/*      color: #1890ff;*/
/*      background: hsla(0, 0%, 100%, 0.85);*/
/*      vertical-align: middle;*/
/*    }*/

/*    .icon {*/
/*      font-size: 16px;*/
/*      padding: 4px;*/
/*    }*/
/*  }*/
/*}*/
</style>
